export const SWITCH_CART_DIALOG = "SWITCH_CART_DIALOG"
export const HIDE_CART_DIALOG = "HIDE_CART_DIALOG"
export const ADD_KIT_TO_CART = "ADD_KIT_TO_CART"
export const ADD_KITS_TO_CART = "ADD_KITS_TO_CART"
export const GET_CART_KITS = "GET_CART_KITS"
export const UPDATE_STEPPER = "UPDATE_STEPPER"
export const GET_DELIVERY_COST = "GET_DELIVERY_COST"
export const GET_PRICE_BREAKDOWN = "GET_PRICE_BREAKDOWN"
export const UPDATE_DELIVERY_COST = "UPDATE_DELIVERY_COST"
export const UPDATE_DISCOUNT = "UPDATE_DISCOUNT"
export const UPDATE_ORDER_DELIVERY_ADDRESS = "UPDATE_ORDER_DELIVERY_ADDRESS"
export const UPDATE_ORDER_BILLING_ADDRESS = "UPDATE_ORDER_BILLING_ADDRESS"
export const UPDATE_DELIVERY_METHOD = "UPDATE_DELIVERY_METHOD"
export const GET_DELIVERY_METHODS = "GET_DELIVERY_METHODS"
export const REDIRECT_TO_PAYMENT = "REDIRECT_TO_PAYMENT"
export const CREATE_STRIPE_SESSION = "CREATE_STRIPE_SESSION"
export const CREATE_ORDER = "CREATE_ORDER";
export const VALIDATE_COUPON = "VALIDATE_COUPON";
export const UPDATE_TRANSFER_INFO = "UPDATE_TRANSFER_INFO";
export const UPDATE_ORDER_Id = "UPDATE_ORDER_ID";
export const EDIT_ORDER = "EDIT_ORDER";
export const EDIT_ALL_ORDER_DETAILS = "EDIT_ALL_ORDER_DETAILS";
export const CREATE_TRANSACTION = "CREATE_TRANSACTION";
export const CREATE_WIRETRANSFER_TRANSACTION = "CREATE_WIRETRANSFER_TRANSACTION";
export const CREATE_STRIPE_TRANSACTION = "CREATE_STRIPE_TRANSACTION";
export const SET_ORDER_EDIT_MODE = "SET_ORDER_EDIT_MODE";
export const CREATE_DEPOSIT = "CREATE_DEPOSIT";
export const CREATE_CREDIT_CARD = "CREATE_CREDIT_CARD"
export const CREATE_WIRE_PAYMENT = "CREATE_WIRE_PAYMENT"
export const CREATE_CARD_PAYMENT = "CREATE_CARD_PAYMENT"
export const REMOVE_KIT_FROM_CART = "REMOVE_KIT_FROM_CART"
export const GET_LATEST_ORDER = "GET_LATEST_ORDER"
export const GET_ORDER_BY_ID = "GET_ORDER_BY_ID";
export const GET_DASHBOARD_ORDER_BY_ID = "GET_DASHBOARD_ORDER_BY_ID";
export const UPDATE_IS_BILLING = "UPDATE_IS_BILLING";
export const UPDATE_STATUS = "UPDATE_STATUS";
export const UPDATE_INSURANCE_PERCENTAGE = "UPDATE_INSURANCE_PERCENTAGE";
export const GET_BILLING_COMPANY = "GET_BILLING_COMPANY";
export const UPDATE_SELLER_SHIPPING_LOGISTICS = "UPDATE_SELLER_SHIPPING_LOGISTICS";
export const GET_SELLER_SHIPPING_LOGISTICS = "GET_SELLER_SHIPPING_LOGISTICS"